<template>
<div>
  <vs-row vs-justify="center">      
    <vs-col type="flex" vs-justify="center" vs-align="center">
      <vs-card class="cardx">
                <div slot="header" class="header-container-flex">
          <h3>Status BoxStreamer {{ boxName }}</h3>
          <vs-button 
            class="ps_btnBack" 
            type="border" 
            icon="navigate_before" 
            :to="{ name: 'GeneralStates'}" 
            color="darkgreen" 
          >Back</vs-button>
        </div>
                <div>
          <BoxState/>
        </div>
      </vs-card>
    </vs-col>
  </vs-row>
</div>
</template>

<script>
import BoxState from './BoxState.vue';

export default {
  name: 'InfoBox',
  components: {
    BoxState,
  },
  data() {
    return {
      // Capturamos el parámetro 'boxName' de la ruta y lo guardamos en data
      boxName: this.$route.params.boxName || 'N/A' 
    }
  },
  // Opcional: Si quieres asegurarte de que se actualice al cambiar de ruta, usa watch
  watch: {
    '$route.params.boxName': {
      immediate: true,
      handler(newBoxName) {
        this.boxName = newBoxName || 'N/A';
      }
    }
  }
}
</script>
<style>
  .vs-button:hover{
    color: white !important;
    background-color: white;
    border-color: white;
  }

  /* NUEVA CLASE PARA EL ENCABEZADO */
  .header-container-flex {
    display: flex; /* Habilita Flexbox */
    justify-content: space-between; /* Mueve los elementos a los extremos */
    align-items: center; /* Centra los elementos verticalmente */
    width: 100%; /* Asegura que ocupe todo el ancho */
  }

  /* AJUSTE PARA EL BOTÓN */
  .ps_btnBack{
    margin: 0; /* Elimina márgenes innecesarios si usas align-items: center */
    /* float: right !important; <-- ELIMINADO: Ya no es necesario con flexbox */
  }
  
  /* Puedes querer añadir un pequeño margen a la derecha del h4 para que no se pegue al borde */
  .header-container-flex h4 {
      margin: 0; 
  }

  .ps_divBack{
    width: 100%;
  }
</style>
